import { IItemForGetShortInfo } from 'types';
import GameCategorySelect from './components/GameCategorySelect';
import GameNameSelect from './components/GameNameSelect';
import DishNameSelect from './components/DishNameSelect';
import DishSubCategorySelect from './components/DishSubCategorySelect';
import TransitionTypeSwitch from './components/TransitionTypeSwitch';
import DishCategorySelect from './components/DishCategorySelect';
import {
	TCreateTeaserSelectedItem,
	TCreateTeaserTransitionType,
} from 'modules/Teasers/CreateTeaser/createTeaserState/createTeaserContext';
import React from 'react';

interface ITransitionTypeField {
	selectedRestaurants: string[];
	setTransitionType: (value: TCreateTeaserTransitionType) => void;
	setTransitionDishCategory: (value: TCreateTeaserSelectedItem) => void;
	setFetchedDishCategories: (value: IItemForGetShortInfo[]) => void;
	selectedTransitionDishCategory: TCreateTeaserSelectedItem;
	setTransitionDishSubCategory: (value: TCreateTeaserSelectedItem) => void;
	setFetchedDishSubCategories: (value: IItemForGetShortInfo[]) => void;
	selectedTransitionDishSubCategory: TCreateTeaserSelectedItem;
	setTransitionDishName: (value: TCreateTeaserSelectedItem) => void;
	setFetchedDishes: (value: IItemForGetShortInfo[]) => void;
	setTransitionGameCategory: (value: TCreateTeaserSelectedItem) => void;
	setFetchedGameCategories: (value: IItemForGetShortInfo[]) => void;
	selectedTransitionGameCategory: TCreateTeaserSelectedItem;
	setTransitionGameName: (value: TCreateTeaserSelectedItem) => void;
	setFetchedGames: (value: IItemForGetShortInfo[]) => void;
	selectedTransitionType: TCreateTeaserTransitionType;
}

const TransitionTypeField: React.FC<ITransitionTypeField> = ({
	selectedRestaurants,
	setTransitionType,
	setTransitionDishCategory,
	setFetchedDishCategories,
	selectedTransitionDishCategory,
	setTransitionDishSubCategory,
	setFetchedDishSubCategories,
	selectedTransitionDishSubCategory,
	setFetchedDishes,
	setTransitionDishName,
	setTransitionGameCategory,
	setFetchedGameCategories,
	selectedTransitionGameCategory,
	setTransitionGameName,
	setFetchedGames,
	selectedTransitionType,
}) => {
	const renderDishFields = () => {
		return (
			<>
				<DishCategorySelect
					selectedRestaurants={selectedRestaurants}
					setFetchedDishCategories={setFetchedDishCategories}
					setTransitionDishCategory={setTransitionDishCategory}
				/>
				<DishSubCategorySelect
					selectedTransitionDishCategory={selectedTransitionDishCategory}
					setTransitionDishSubCategory={setTransitionDishSubCategory}
					setFetchedDishSubCategories={setFetchedDishSubCategories}
				/>
				<DishNameSelect
					selectedRestaurants={selectedRestaurants}
					selectedTransitionDishSubCategory={selectedTransitionDishSubCategory}
					setFetchedDishes={setFetchedDishes}
					setTransitionDishName={setTransitionDishName}
				/>
			</>
		);
	};

	const renderGameFields = () => {
		return (
			<>
				<GameCategorySelect
					selectedRestaurants={selectedRestaurants}
					setFetchedGameCategories={setFetchedGameCategories}
					setTransitionGameCategory={setTransitionGameCategory}
				/>
				<GameNameSelect
					selectedRestaurants={selectedRestaurants}
					selectedTransitionGameCategory={selectedTransitionGameCategory}
					setFetchedGames={setFetchedGames}
					setTransitionGameName={setTransitionGameName}
				/>
			</>
		);
	};

	const showDishFields = selectedTransitionType === 'dish';
	const showGameFields = selectedTransitionType === 'game';

	return (
		<>
			<TransitionTypeSwitch setTransitionType={setTransitionType} />
			{showDishFields && renderDishFields()}
			{showGameFields && renderGameFields()}
		</>
	);
};

export default React.memo(TransitionTypeField);
